import api from '../API/api';
import axios from 'axios';

const debug = false;
export async function getPublications(){
    try{
        const response = await api.get('v1/publications/');
        return response.data;
    } catch(error) {
        console.error("Failed to fetch publications:", error);
        return [];
    }
}


export async function getPublication(id){
    try{
        const response = await api.get(`v1/publications/${id}/`);
        return response.data;
    } catch(error) {
        console.error("Failed to fetch publications:", error);
        return [];
    }
}

export async function getPublicPublication(id){
    try{
        const response = await api.get(`v1/publications/${id}/public/`);
        return response.data;
    } catch(error) {
        console.error("Failed to fetch publications:", error);
        return [];
    }
}


export async function getMyPublications(){
    try{
        const response = await api.get('v1/publications/my/');
        return response.data;
    } catch(error) {
        console.error("Failed to fetch my publications:", error);
        return [];
    }
}

export async function getEvents() {
    try {
        const response = await api.get('v1/events/');
        return response.data;
    } catch (error) {
        console.error("Failed to fetch events:", error);
        return [];
    }
}

export async function getEventDetails(eventId) {
    try {
        const response = await api.get(`v1/events/${eventId}/`);
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch event details for event ID ${eventId}:`, error);
        return {};
    }
}

export async function getJobs() {
    try {
        const response = await api.get('v1/jobs/');
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch jobs:", error);
        return [];
    }
}

export async function getMyJobs() {
    try {
        const response = await api.get('v1/jobs/my/');
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch jobs:", error);
        return [];
    }
}

export async function getJobDetails(jobId) {
    try {
        const response = await api.get(`v1/jobs/${jobId}/`);
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch job details for job ID ${jobId}:`, error);
        return {};
    }
}


export async function checkBeforeFillEmpregabilidadeForm() {
    try {
        const response = await api.get('v1/forms/graduate-survey/status/');
        console.log(response)
        return response.data;
    }catch (error){
        console.log('Failed to check if the user can fill the form', error)
        return {}
    }
}

export async function getSurveyData(id){
    try {
        const response = await api.get(`v1/forms/graduate-survey-detail/${id}/`);
        console.log(response)
        return response.data;
    } catch (error) {
        console.error("Failed to fetch survey data:", error);
        return {};
    }
}

export async function getMyPatronRequest(){
    try {
        const response = await api.get('v1/graduate/patron/my/');
        if (response.status !== 200){
        return false;
        }
        return true;
    } catch (error) {
        return false;
    }
}


export async function getMyRequestsToHelp(){
    try {
        const response = await api.get('v1/forms/help/my/');
        console.log(response)
        return response.data;
    } catch (error) {
        console.error("Failed to fetch my request to UEM:", error);
        return [];
    }
}


export async function getPublicPublications(){
    try{
        const response = await axios.get(debug ? `http://localhost:8000/api/v1/publications/public/` : `https://api.alumni.uem.mz/api/v1/publications/public/`);
        return response.data;
    } catch(error) {
        console.error("Failed to fetch public publications:", error);
        return [];
    }
}

export async function getPublicEvents(){
    try{
        const response = await axios.get(debug ? `http://localhost:8000/api/v1/events/public/` : `https://api.alumni.uem.mz/api/v1/events/public/`);
        return response.data;
    } catch(error) {
        console.error("Failed to fetch public events:", error);
        return [];
    }
}


export async function getInqueritos(){
    try{
        const response = await api.get(debug ? `http://127.0.0.1:8000/api/v1/builder/forms/avalaible` : `https://api.alumni.uem.mz/api/v1/builder/forms/available`);
        return response.data;
    } catch(error) {
        console.error("Failed to fetch inqueritos:", error);
        return [];
    }
}

export async function getInqueritoDetails(id){
    try{
        const response = await api.get(debug ? `http://127.0.0.1:8000/api/v1/builder/forms/${id}/questions/` : `https://api.alumni.uem.mz/api/v1/builder/forms/${id}/questions/`);
        return response.data;
    }
    catch(error) {
        console.error("Failed to fetch inquerito details:", error);
        return {};
    }
}

export async function getInqueritoDetailsWithConditions(id){    
   try{
        const response = await api.get(debug ? `http://127.0.0.1:8000/api/v1/builder/forms/${id}/questions-conditions/` : `https://api.alumni.uem.mz/api/v1/builder/forms/${id}/questions-conditions/`);
        return response.data;
    }
    catch(error) {
        console.error("Failed to fetch inquerito details:", error);
        return {};
    }
}  